import { useCustomSitecoreContext } from './useCustomSitecoreContext';

export const useCurrentSiteUrls = () => {
  const context = useCustomSitecoreContext();
  const currentSiteBaseUrl = context?.currentSiteBaseUrl ?? '';
  const currentPageUrl = `${currentSiteBaseUrl}${context?.itemPath}`;

  return {
    currentSiteBaseUrl,
    currentPageUrl,
  };
};
